import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";
import { getSettingFactory } from "@faire/web/common/SerializedSetting";
import * as Setting from "@faire/web-api/indigofair/settings/Setting";

type CommonPageSerializedSetting =
  | Setting.BATCH_EVENT_FLUSH_QUEUE_LENGTH
  | Setting.BATCH_EVENT_FLUSH_INTERVAL_MS
  | Setting.DEFAULT_ADDRESS_SCHEMA_OVERRIDE
  | Setting.ENABLE_EVENTS_BATCHING_221102
  | Setting.TWITTER_EVENT_NAME_TO_ID
  | Setting.ENABLE_BRAND_IMAGE_AUTO_CROPPING_230602
  | Setting.OPTIMIZE_IMAGE_URL_FOR_IMPROVED_CACHE_HIT_231218
  | Setting.BRAND_PORTAL_OPTIMIZE_IMAGE_URL_FOR_IMPROVED_CACHE_HIT_240422
  | Setting.UPLT_PAGE_NAMES_ENABLE_PAGE_UPDATE_FIX
  | Setting.ENABLE_PETE_OPEN_TELEMETRY_TRACES_240218
  | Setting.OPEN_TELEMETRY_COLLECTOR_URL
  | Setting.ENABLE_MARK_AS_UNREAD_FOR_BRANDS_240702
  | Setting.ENABLE_MARK_AS_UNREAD_FOR_RETAILERS_240702
  /**
   * This is only serialized in retailer, but the code exists in web. It's gated via presence of a retailer.
   */
  | Setting.EVENTS_BATCHING_LATENCY_AB_EXPERIMENT_240208
  | Setting.ABSOLUTE_LINK_DOMAIN_STRIPPING_240201
  | Setting.ENABLE_DETAILED_SESSION_TRACING_240424
  | Setting.ENABLE_SPE_DESIGN_REVAMP_PHASE1_240717
  | Setting.LISTING_QUALITY_INTERFACE_REVAMP_240814
  | Setting.TEXT_ANNOTATION_DETECTION_ENABLED_240729
  | Setting.FACEBOOK_RETAILER_PIXEL_ID;

const {
  getSettingValueWithoutAssignment,
  getSettingValueAndAssign,
  assignSetting,
} = getSettingFactory<CommonPageSerializedSetting>(() =>
  getGlobalProperty("settingsValues", {})
);

export {
  assignSetting,
  getSettingValueAndAssign,
  getSettingValueWithoutAssignment,
};
